<template>
  <div>
    <form class="md:flex md:align-top" @submit.prevent="submitFilters">
      <div
        class="mb-16 grid flex-1 grid-cols-2 gap-16 overflow-hidden md:grid-cols-5"
        :class="{ 'max-h-56': !shouldShowAllFilters }"
      >
        <RevInputText
          id="order-id"
          v-model="filtersValues.orderId"
          :label="i18n(sharedTranslations.orderNumber)"
        />
        <InputSelectMarket v-model="filtersValues.market as string" />
        <RevInputDate
          id="start-date"
          v-model="filtersValues.startDate"
          :label="i18n(sharedTranslations.startDate)"
          type="date"
        />
        <RevInputDate
          id="end-date"
          v-model="filtersValues.endDate"
          :label="i18n(sharedTranslations.endDate)"
          type="date"
        />
        <InputSelectCategory v-model="filtersValues.categoryId as string" />
        <RevInputText
          id="min-rate"
          v-model="filtersValues.minRate"
          :label="i18n(sharedTranslations.ratingMin)"
          :max="RATE.MAX"
          :min="RATE.MIN"
          type="number"
        />
        <RevInputText
          id="max-rate"
          v-model="filtersValues.maxRate"
          :label="i18n(sharedTranslations.ratingMax)"
          :max="RATE.MAX"
          :min="RATE.MIN"
          type="number"
        />
      </div>
      <div class="ml-16">
        <RevButton type="submit" variant="primary">
          {{ i18n(sharedTranslations.submit) }}
        </RevButton>
        <RevLink class="ml-16" type="button" @click="resetFilters">
          {{ i18n(sharedTranslations.reset) }}
        </RevLink>
      </div>
    </form>
    <div class="mb-8">
      <RevButton size="small" variant="secondary" @click="toggleMoreFilters">
        <template v-if="shouldShowAllFilters">
          {{ i18n(translations.showLess) }}
        </template>
        <template v-else>
          {{ i18n(translations.showMore) }}
        </template>
      </RevButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevInputDate } from '@ds/components/InputDate'
import { RevInputText } from '@ds/components/InputText'
import { RevLink } from '@ds/components/Link'

import { RATE } from '../../Filters.constants'
import sharedTranslations from '../../Filters.translations'
import type { FilterValues } from '../../Filters.types'

import translations from './FiltersDesktop.translations'

const i18n = useI18n()

const filtersValues = defineModel<FilterValues>('filtersValues', {
  required: true,
})

defineProps<{
  resetFilters: () => void
  submitFilters: () => void
}>()

const shouldShowAllFilters = ref(false)

function toggleMoreFilters() {
  shouldShowAllFilters.value = !shouldShowAllFilters.value
}
</script>
